import { render } from "./ChangePassword.vue?vue&type=template&id=c6531a2a&scoped=true"
import script from "./ChangePassword.vue?vue&type=script&lang=ts"
export * from "./ChangePassword.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-c6531a2a"

export default script